'use client';

import { c as _c } from "react/compiler-runtime";
import { redditEmbedSrc } from '@shared/all/helpers/redditEmbed';
import { useSyncExternalStore } from 'react';

// Reddit's embed has no height message we rely on, so the frame is a fixed
// height and scrolls inside.
const EMBED_HEIGHT_PX = 520;

// The page theme is the `data-theme` attribute on <html> (hooks/useDarkMode).
const subscribeTheme = (onChange: () => void) => {
  const observer = new MutationObserver(onChange);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['data-theme']
  });
  return () => observer.disconnect();
};
type Theme = 'light' | 'dark';
const readTheme = (): Theme => document.documentElement.getAttribute('data-theme') === 'light' ? 'light' : 'dark';
type Props = {
  permalink: string;
};

/**
 * Reddit's own embed of a post (EMBED_REMOTE, .specs/scrapers.md): their
 * bytes, their server, our frame. We store only the permalink.
 */
const RedditEmbed = t0 => {
  const $ = _c(6);
  const {
    permalink
  } = t0;
  const theme = useSyncExternalStore(subscribeTheme, readTheme, _temp);
  let t1;
  if ($[0] !== permalink || $[1] !== theme) {
    t1 = redditEmbedSrc(permalink, theme);
    $[0] = permalink;
    $[1] = theme;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const src = t1;
  if (!src) {
    return null;
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      height: EMBED_HEIGHT_PX
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== src) {
    t3 = <iframe src={src} title="Reddit post" loading="lazy" sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox" className="mt-3 w-full rounded-md border border-ds-border-subtle" style={t2} />;
    $[4] = src;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default RedditEmbed;
function _temp() {
  return "dark";
}